@if (!showReUploadModal) {
  <div class="file-status-overlay">
    <div class="file-status-modal">
      <div class="file-status-modal-header">
        <h4>Uploading Files</h4>
        <div class="upload-warning-alert">
          <i class="fa-solid fa-triangle-exclamation"></i>
          Please do not close this browser until the confirmation page is displayed.
        </div>
      </div>
      <div class="table-margin">
        <div class="file-status-table-header row m-0">
          <div class="col-6"><b>File Name</b></div>
          <div class="col-3"><b>File Size</b></div>
          <div class="col-3"><b>Status</b></div>
        </div>
      
        <div class="file-status-table-body">
          @for (file of FilesToUpload; track file) {
          <div class="row m-0 file-row">
            <div class="col-6 text-break">{{ file.fileName }}</div>
            <div class="col-3">{{ file.sizeReadable }}</div>
            <div class="col-3">
              @if (getStatusText(file) === 'Complete') {
              <span class="status-complete"><i class="fa-solid fa-circle-check"></i> Complete</span>
              } @else if (getStatusText(file) === 'Error in Upload') {
              <span class="status-error"><i class="fa-solid fa-circle-xmark"></i> Error in Upload</span>
              } @else {
              <span class="status-inprogress"><i class="fa-solid fa-spinner fa-spin"></i> In Progress</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      @if (allFilesComplete) {
        <div class="upload-complete-footer">
          Upload complete. Redirecting to confirmation...
        </div>
      }
      @if (hasErrorInUpload) {
        <div class="p-3">
          <button type="button" class="btn-enter" (click)="openReUploadModal()">Remove/Replace All Errored Uploads</button>
        </div>
      }
    </div>
  </div>
}

<!-- Re-Upload Modal -->
@if (showReUploadModal) {
  <div class="file-status-overlay">
    <div class="file-status-modal reupload-modal">
      <div class="reupload-header">
        <h4>Remove/Replace Attachments</h4>
        <p class="reupload-instruction">All failed uploads have been removed. If you wish to add/replace files, please attach the files below (optional). When finished, click "Submit".</p>
      </div>

      <div class="reupload-content row m-0">
        <!-- File Upload Area -->
        <div class="col-6 reupload-dropzone-container">
          <div class="reupload-dropzone" fileDragDrop (filesChangeEmiter)="onReUploadFileChange($event)">
            <input type="file" name="reUploadFile" id="reUploadFile" #reUploadFileInput
              (change)="onReUploadFileChange($event.target)" multiple style="display:none">
            <div class="upload-content">
              <i class="fa-solid fa-cloud-arrow-up upload-arrow"></i>
              <span class="drag-text">Drag and drop your files here.</span>
              <span class="or-text">or</span>
              <label for="reUploadFile" class="browse-btn">Browse Computer</label>
            </div>
          </div>
          @if (reUploadError) {
            <div class="reupload-error">
              <span class="text-danger">{{ reUploadError }}</span>
            </div>
          }
        </div>

        <!-- Files List -->
        <div class="col-6 reupload-file-list-container">
          <div class="reupload-file-list-header"><b>Files Selected For Upload</b></div>
          <div class="reupload-table-header row m-0">
            <div class="col-4"><b>Action</b></div>
            <div class="col-5"><b>File Name</b></div>
            <div class="col-3"><b>File Size</b></div>
          </div>
          <div class="reupload-table-body">
            @for (file of reUploadFilesList; track file) {
              <div class="row m-0 file-row">
                <div class="col-4">
                  @if (file.alreadyUploaded) {
                    <span class="text-success">Upload complete</span>
                  }
                  @if (!file.alreadyUploaded) {
                    <button type="button" class="btn-enter btn-sm" (click)="removeReUploadFile(file)">Remove</button>
                  }
                </div>
                <div class="col-5 text-break">{{ file.fileName }}</div>
                <div class="col-3">{{ file.sizeReadable }}</div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="reupload-footer">
        <button type="button" class="btn-enter" (click)="submitReUpload()">Submit</button>
      </div>
    </div>
  </div>
}
